$ = jQuery.noConflict();

$(() => {

	$('.region-sidebar-first li.expanded > a').on('click', function(event){
		event.preventDefault();
		let el = $(this).parent();
		if(el.hasClass('expanded-active')){
			el.removeClass('expanded-active');
		}else{
			el.addClass('expanded-active');
		}
	});

});
